import Framework from "./framework";
import ShoppingCartWidget from "./components/ShoppingCartWidget.vue";

const ShoppingCart = {
  install: (Vue) => {
    Vue.component("shopping-cart-widget", ShoppingCartWidget);

    Vue.prototype.$shoppingCart = new Framework();
  },
};

export default ShoppingCart;
